import { DataKeyValueStringInterface } from '@propertyfinder/pf-frontend-common/src/module/data/key-value/string.interface';
import { HttpApiResponseInterface } from '@propertyfinder/pf-frontend-common/src/module/http/api-response.interface';
import { ApiServiceInterface } from '@propertyfinder/pf-frontend-common/src/service/api/service.interface';

import { CountryModel } from 'common/data/country/model';
import { ApiEndpointServiceInterface } from 'common/service/api-endpoint/service.interface';
import { CountryStoreServiceInterface } from 'common/service/country-store/service.interface';

import { CountrySortEnum } from './sort.enum';

export class CountryStore implements CountryStoreServiceInterface {
  /**
   * Country models cache
   */
  private models: Partial<Record<CountrySortEnum, Promise<CountryModel[]>>> = {};

  /**
   * API endpoints to connect with the backend
   */
  private endpoint: { [key: string]: DataKeyValueStringInterface } = {
    getCountries: {
      path: this.apiEndpointService.getPath('/countries'),
      method: 'GET',
    },
  };

  /**
   * Constructor
   */
  constructor(private apiEndpointService: ApiEndpointServiceInterface, private apiService: ApiServiceInterface) {}

  /**
   * @inheritDoc
   */
  public getAll(sort?: CountrySortEnum): Promise<CountryModel[]> {
    // Previously loaded
    if (this.models[sort]) {
      return this.models[sort];
    }

    return (this.models[sort] = this.apiService
      .request(
        this.endpoint.getCountries.method,
        this.endpoint.getCountries.path,
        sort
          ? {
              sort,
            }
          : null
      )
      .then((response: HttpApiResponseInterface) => response.data)
      .catch((response) => {
        // eslint-disable-next-line no-console
        console.error('Failed to load countries', response);
        return Promise.reject(null);
      }));
  }
}
